import type { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';

/** Focused create/edit view: a back link + title, with the list hidden behind it. */
export function FormShell({ title, onBack, children }: { title: string; onBack: () => void; children: ReactNode }) {
  return (
    <section className="mt-6 animate-fade-up">
      <button type="button" onClick={onBack} className="inline-flex items-center gap-1.5 text-sm text-muted hover:text-ink">
        <ArrowLeft className="size-4" aria-hidden /> Back
      </button>
      <h1 className="mt-3 font-display text-display-md text-ink">{title}</h1>
      <div className="mt-4">{children}</div>
    </section>
  );
}
